import React from "react";
import { useTheme } from "@mui/material";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

const IconIssue = ({ ...props }) => {
  const theme = useTheme();

  return (
    <FontAwesomeIcon
      icon={faExclamationTriangle}
      color={theme.palette._components.alert.error.color}
      {...props}
    />
  );
};

export default IconIssue;
